export default () => {
  const data = {
    event_name: 'click',
    button_name: 'banner_tegra',
    page_section: 'sponsored_banner',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
